import { render, staticRenderFns } from "./AbandonedCart.vue?vue&type=template&id=14082312"
import script from "./AbandonedCart.vue?vue&type=script&lang=js"
export * from "./AbandonedCart.vue?vue&type=script&lang=js"
import style0 from "./AbandonedCart.vue?vue&type=style&index=0&id=14082312&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports